<template>
  <fieldset class="fieldset">
    <v-label
      v-if="text"
      :id="id"
      :text="text"
    />
    <v-select
      v-if="selectOptions"
      :id="id"
      :name="name"
      :placeholder="placeholder"
      :options="selectOptions"
      :is-required="isRequired"
      :is-mini="isMini"
      :value="value"
      @change="inputChange"
    />
    <div v-else-if="type === 'display'">
      {{ value }}
    </div>
    <v-textarea
      v-else-if="type === 'textarea'"
      :id="id"
      :name="name"
      :placeholder="placeholder"
      :pattern="pattern"
      :is-required="isRequired"
      :is-mini="isMini"
      :value="value"
      :maxlength="maxlength"
      @input="inputChange"
      @keyup="keyupChange"
    />
    <v-password
      v-else-if="type === 'password'"
      :id="id"
      :name="name"
      :placeholder="placeholder"
      :pattern="pattern"
      :is-required="isRequired"
      :is-mini="isMini"
      :value="value"
      @input="inputChange"
      @keyup="keyupChange"
    />
    <v-input
      v-else
      :id="id"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      :pattern="pattern"
      :is-required="isRequired"
      :is-mini="isMini"
      :value="value"
      :readonly="readonly"
      :maxlength="maxlength"
      @input="inputChange"
      @keyup="keyupChange"
    />
    <v-inputHelp
      v-if="helpText"
      class="fieldset__text"
      :text="helpText"
    />
  </fieldset>
</template>

<script>
  import Label from "@/atoms/Label";
  import Textarea from "@/atoms/Textarea";
  import Password from "@/atoms/Password";
  import Input from "@/atoms/Input";
  import Select from "@/atoms/Select";
  import InputHelp from "@/atoms/InputHelp";

  export default {
    components: {
      "v-label": Label,
      "v-password": Password,
      "v-input": Input,
      "v-textarea": Textarea,
      "v-select": Select,
      "v-inputHelp": InputHelp
    },
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      value: {
        type: [String,Number],
        default: null
      },
      text: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: null
      },
      pattern: {
        type: String,
        default: null
      },
      helpText: {
        type: String,
        default: null
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      isMini: {
        type: Boolean,
        default: false
      },
      selectOptions: {
        type: Array,
        default: null
      },
      readonly:{
        type: Boolean,
        default: false
      },
      maxlength:{
        type: String,
        default: null
      }
    },
    methods: {
      inputChange(val) {
        this.$emit('input', val)
      },
      keyupChange(val){
        this.$emit('keyup', val);
      }

    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .fieldset {
    position: relative;
    border: 0;
    margin-bottom: 20px;
    &__text {
      position: absolute;
      top: 100%;
      width: 100%;
      left: 0;
    }
    &[class*='col'] &__text {
      left: 5px;
    }
  }
</style>
